import { hasValidContrastRatio } from '@trello/a11y';
import { Yellow500 } from '@trello/colors';
import { dangerouslyGetComputedToken, token } from '@trello/theme';

import { dynamicToken } from '../dynamicToken';
import type { GetDynamicTokens } from './getDynamicTokens';

/**
 * Assign a dynamic star color based on the board background color.
 * If the equivalent yellow star token from ADS has a valid contrast ratio,
 * we use it; otherwise, we fallback to the value of the `dynamic.icon` token.
 * Note that this has an explicit dependency on the `dynamic.text` token
 * and must be fetched in tandem.
 */
export const getDynamicStarToken: GetDynamicTokens<'dynamic.star'> = ({
  background: { backgroundColor },
  colorMode,
}) => {
  if (colorMode === null) {
    return { 'dynamic.star': Yellow500 };
  }

  const computedStarToken = dangerouslyGetComputedToken(
    'trello.color.icon.star',
  );

  if (
    !backgroundColor ||
    hasValidContrastRatio(backgroundColor, computedStarToken, 16, false).isValid
  ) {
    return { 'dynamic.star': token('trello.color.icon.star') };
  }

  return { 'dynamic.star': dynamicToken('dynamic.icon') };
};
